<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7C4 6.44772 4.44772 6 5 6H15C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H5C4.44772 8 4 7.55228 4 7Z"
      fill="currentColor"
    />
    <path
      d="M4 13C4 12.4477 4.44772 12 5 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H5C4.44772 14 4 13.5523 4 13Z"
      fill="currentColor"
    />
  </svg>
</template>
